export default __webpack_public_path__ + "static/media/news2.5d3308cc.png";